import _ from 'lodash';
import * as Sentry from '@sentry/browser';
import { getUser } from '~src/user';
import { mixpanel } from './config/mixpanelConfig';
import { initProductFruits } from './initProductFruits';
import { initEventListenersForTracking } from './utils/initEventListenersForTracking';

export const initAnalytics = async () => {
  const { user } = await getUser();

  Sentry.setUser({
    id: user.objectId,
    email: user.username,
    username: `${user.first_name || ''} ${user.last_name || ''}`.trim(),
    organization: user.org_pointer.nome,
  });

  Sentry.setContext('organization', {
    id: user.org_pointer.objectId,
    name: user.org_pointer.nome,
  });

  mixpanel.identify(user.objectId);
  mixpanel.set_group('company', user.org_pointer.nome);

  mixpanel.people.set({
    company: user.org_pointer.nome,
    $name: `${user.first_name} ${user.last_name}`,
    $email: user.username,
    $org_id: user.org_pointer.objectId,
    $org_name: user.org_pointer.nome,
    $org_plan: user.org_pointer.plan,
    $org_lifecyclestage: user.org_pointer.tipo_istanza,
    $org_amministratore_principale: user.super_admin,
    $org_utente_attivo: user.user_status,
  });

  initProductFruits();

  initEventListenersForTracking();

  if (_.has(user, 'org_pointer.stripe_customer_id')) {
    window.profitwell('start', {
      user_id: user.org_pointer.stripe_customer_id,
    });
  }
};
